module.exports = __webpack_public_path__ + "static/media/workable.65486e09.svg";